import React, { Component, Fragment } from 'react';
import { hydrate } from 'react-dom';
import Helmet from 'react-helmet';
import { hot } from 'react-hot-loader/root';

import { BrowserRouter } from 'react-router-dom';

import App from 'client/components/app/app';

import ellipsis from 'client/utils/ellipsis';
import LangContext from 'client/utils/lang-context';

import { BundleData, BundleProps } from './types';

import './desktop.css';

class Bundle extends Component<BundleProps> {
    render() {
        const { data:
            {
                lang,
                common,
                baseUrl,
                dictionary
            }
        } = this.props;

        const { description, favicon, twittercard, og, icons } = common.seo;

        const siteName = `${dictionary.sitename}, ${dictionary.mainname}`;
        const preparedDescription = ellipsis(description, 300);

        return (
            <Fragment>
                <Helmet>
                    <html />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <link rel="canonical" href={baseUrl} />
                    <meta name="description" content={preparedDescription} />

                    <meta property="og:url" content={baseUrl} />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content={siteName} />
                    <meta property="og:description" content={preparedDescription} />
                    <meta property="og:image" content={og.image} />
                    <meta property="og:image:width" content={og.width} />
                    <meta property="og:image:height" content={og.height} />

                    <meta name="twitter:site" content={siteName} />
                    <meta name="twitter:card" content={twittercard} />
                    <meta property="twitter:description" content={preparedDescription} />

                    <link rel="shortcut icon" href={favicon} />
                    <link rel="shortcut icon" href={icons[16]} sizes="16x16" />
                    <link rel="shortcut icon" href={icons[32]} sizes="32x32" />
                    <link rel="shortcut icon" href={icons[192]} sizes="192x192" />
                    <link rel="apple-touch-icon" href={icons[76]} sizes="76x76" />
                    <link rel="apple-touch-icon" href={icons[120]} sizes="120x120" />
                    <link rel="apple-touch-icon" href={icons[152]} sizes="152x152" />
                    <link rel="apple-touch-icon" href={icons[180]} sizes="180x180" />
                </Helmet>

                <LangContext.Provider
                    value={{
                        lang,
                        dictionary
                    }}
                    >
                    <App {...this.props} />
                </LangContext.Provider>
            </Fragment>
        );
    }
}

export const DesktopBundle = hot(Bundle);

export default (data: BundleData) => {
    hydrate(
        <BrowserRouter>
            <DesktopBundle data={data} />
        </BrowserRouter>,
        document.getElementById('mount')
    );
};
